import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/barmer.jpg";
import Newsletter from "../../shared/Newsletter";
import { Helmet } from 'react-helmet';
const Barmer = () => {
  return (
    <>
      <Helmet>
        <title>Barmer, Rajasthan | The Rustic Paths</title>

        <meta charset="UTF-8" />

        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <meta
          name="description"
          content="Discover the vibrant city of Barmer in Rajasthan, India with The Rustic Paths. Immerse yourself in the rich cultural tapestry, explore local traditions, and experience the colorful landscapes of Barmer. Plan your journey with our private driver services and delve into the unique charm of this Rajasthan gem."
        />
        <meta
          name="keywords"
          content="Barmer, Rajasthan, private driver, cultural tapestry, local traditions, colorful landscapes"
        />
        <meta name="author" content="The Rustic Paths" />

        
      </Helmet>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">Barmer</h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Barmer Fort</li>
                      <li>Hawa Mahal</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Barmer
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Barmer was founded around the 12th century. It forms the
                    border area of India-Pakistan. Barmer is situated at a
                    distance of 224km from Jodhpur on the Luni-Munabao section
                    of the Northern Railways. Located atop a hill as so many of
                    the cities of western Rajasthan are, it houses the remains
                    of an old fort called Garh right on its peak. The name
                    Barmer is derived from the ruler Bahada Rao or Bar Rao who
                    is said to have founded the town in the 13th century.
                    Initially called 'Bahada-mer' it was later shortened to
                    Barmer.
                  </p>
                  <p>
                    A major attraction for the tourists, it is the centre for
                    wood carving, carpets, embroidery, block printing and other
                    handicrafts. The products made here are popular throughout
                    India. Two annual fairs are celebrated in Barmer; the Barmer
                    Thar festival in early March and the Barmer cattle fair in
                    March/April. The tourist attractions in the tiny town of
                    Barmer range from the historical forts to colorful festivals
                    adding color and warmth to the otherwise dry landscape.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Barmer Fort
                  </h2>

                  <p>
                    Famous Fort Siwana is situated on a hilltop. The fort was
                    built by a famous Rajput ruler Raja Bhoj's son Veernarayan,
                    who at one stage controlled much of Barmer and had close
                    ties with the Solanki dynasty of Gujarat. The fort is not in
                    the best of condition now however it still houses a
                    beautiful pond. The fort fell to forces of Alauddin Khilji
                    in 1308. When Alauddin Khilji, the Sultan of Delhi, besieged
                    the fort the people led by Sutal Deo mounted a heroic
                    defence.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Kiradu Temples
                  </h2>
                  <p>
                    The Kiradu temples are located at about 35 km from Barmer.
                    There are five temples in all and most remarkable of them is
                    Someshvara Temple. These temples feature impressive
                    sculpture and a Solanki style of architecture.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Barmer;
